import { State } from '../Store';

export const selectCustomers = (state: State) => state.customers || [];
